import axios from "axios";
import CustomToast from "../../components/Toast";
import { Navigate } from "react-router-dom";
import CryptoJS from "crypto-js";

// Axios instance creation
const axiosMain = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_END_POINT_URL_DEV
      : process.env.REACT_APP_END_POINT_URL_PROD,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${atob(localStorage.getItem("argument1"))}`,
    Userid: localStorage.getItem("argument2")
      ? atob(localStorage.getItem("argument2"))
      : 0,
    Trackloginid: localStorage.getItem("argument7")
      ? atob(localStorage.getItem("argument7"))
      : 0,
  },
});

// Encryption constants
const secretKey = "08090a0b0c0d0e0f"; // Same secret key used for encryption/decryption
const IV_KEY = "18191a1b1c1d1e1f"; // IV

// Encrypt data function
const encryptData = (data) => {
  try {
    const stringData = typeof data === "string" ? data : JSON.stringify(data);
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse(IV_KEY);
    const encryptedValue = CryptoJS.AES.encrypt(stringData, key, {
      iv,
    }).ciphertext.toString(CryptoJS.enc.Base64);
    return encryptedValue;
  } catch (error) {
    console.error("Error encrypting data:", error);
    return null;
  }
};

// Axios request interceptor
axiosMain.interceptors.request.use(
  (config) => {
    // Re-encrypting Authorization and other headers
    config.headers.Authorization = `Bearer ${atob(
      localStorage.getItem("argument1")
    )}`;
    config.headers.Userid = localStorage.getItem("argument2")
      ? atob(localStorage.getItem("argument2"))
      : 0;
    config.headers.Trackloginid = localStorage.getItem("argument7")
      ? atob(localStorage.getItem("argument7"))
      : 0;
    config.headers.auctionCenterMappedIds = localStorage.getItem(
      "auctiocenterId"
    )
      ? atob(localStorage.getItem("auctiocenterId"))
      : 0;
    config.headers.rolecode = localStorage.getItem("argument6")
      ? atob(localStorage.getItem("argument6"))
      : 0;
    config.headers["Content-Type"] = "application/json";

    // Encrypting data for POST/PUT requests
    if (config.method === "abc" || config.method === "abc") {
      config.headers["X-Encrypted"] = "application/json"; // Indicating encrypted data
      if (config.data) {
        // if (!(config.url.toString().includes("/auctionbid/"))) {
        config.data = encryptData(config.data); // Encrypting the request body
        config.headers.isEncrypt = true; // Setting the isEncrypt flag
        // }
      }
    }

    // Encrypting GET request URL
    if (config.method === "abc") {
      // if (!(config.url.toString().includes("/preauction/") || config.url.toString().includes("/auctionbid/"))) {
      const encryptedUrl = encryptData(config.url); // Encrypting the URL
      const safeEncrypted = encryptedUrl
        .replace(/\//g, "$");

      config.url = config.url + "/" + safeEncrypted;
      console.log("Encrypted GET URL:", encryptedUrl); // Logging the encrypted GET URL
      config.headers.isEncrypt = true; // Setting the isEncrypt flag for GET requests
      // }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Axios response interceptor
axiosMain.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const data = error.response.data;
      const previewStatusCode = data.statusCode;
      const status = error.response.status;

      if ("401" === (data && data.statusCode)) {
        if (localStorage.getItem("argument1") != null) {
          CustomToast.error(data && data.message);
          sessionStorage.clear();
          localStorage.clear();
          sessionStorage.removeItem("argument1");
          sessionStorage.removeItem("isLogged");
          localStorage.removeItem("isLogged");
          <Navigate to="login" />;
        }
        return;
      }

      switch (status) {
        case 400:
          console.log("network error");
          break;
        case 404:
          break;
        case 500:
          CustomToast.error("500 Internal Server Error");
          break;
        case 200:
          if (previewStatusCode === 204) {
            CustomToast.error("No Data Found");
          }
          break;
        default:
          console.log("Error:", data, previewStatusCode);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosMain;
